'use client'
/**
 * Returns the initial state for the SdkStore
 */
const createInitialStates = (dynamicContextProps) => ({
    dynamicContextProps,
    loadingAndLifecycle: {
        sessionValidation: false,
    },
    nonce: { expiresAt: undefined, nonce: undefined },
    primaryWalletId: undefined,
    projectSettings: { expiresAt: undefined, settings: undefined },
    sendBalanceState: {
        amount: undefined,
        chainName: undefined,
        nativePrice: undefined,
    },
    tokenBalancesState: {
        error: undefined,
        isError: false,
        isLoading: false,
        tokenBalances: undefined,
    },
    user: undefined,
    walletOptions: {
        groups: {},
        walletConnectorOptions: [],
    },
});
/**
 * Filters out which variables should be stored to local storage.
 * Also allows transforming them before storage.
 */
const transformStateForLocalStorage = (state) => ({
    nonce: state.nonce,
    primaryWalletId: state.primaryWalletId,
    projectSettings: state.projectSettings,
    user: state.user,
});

export { createInitialStates, transformStateForLocalStorage };
